import standardColors from './standardColors';

export const defaultTheme = {
  ...standardColors,
  primary: {
    blue: [standardColors.Primary_100],
    lightBlue: [standardColors.Info_100],
    white: [standardColors.White],
    action: [standardColors.Action],
  },
  secondary: {
    green: [standardColors.Success_100],
    yellow: [standardColors.Caution_100],
    red: [standardColors.Alert_100],
    lightBlue: ['#70BBCD'],
  },
  backgroundColor: standardColors.White,
  textColor: standardColors.Primary_100,
  textSecondaryColor: standardColors.Primary_50,
  actionColor: standardColors.Action,
  ContentBoxColor: standardColors.White,
  borderColor: standardColors.GreyC_60,
  errorColor: standardColors.Alert_100,
  disabledColor: standardColors.GreyC_60,
  technicalErrorColor: standardColors.Primary_100,
  button: {
    primary: {
      backgroundImage: 'linear-gradient(to top, #0097CF, #00AAE8)',
      borderColor: '#37B0DE',
      hoverShadow: '0 0.125em 0.25em 0 rgba(0, 159, 218, 0.6)',
      backgroundImageHover: 'linear-gradient(to top, #0499CF, #00AAE8)',
      disabledColor: '#008CBF',
      pressedColor: standardColors.Action,
      textColor: standardColors.White,
      disabledTextColor: 'rgba(255, 255, 255, 0.6)',
    },
    secondary: {
      backgroundImage: 'linear-gradient(to top, #F5F5F5, #FFFFFF 47%, #FFFFFF)',
      borderColor: 'rgba(0, 55, 85, 0.12)',
      hoverShadow: '0 0.125em 0.25em 0 rgba(0, 55, 85, 0.12)',
      backgroundImageHover:
        'linear-gradient(to top, #F7F7F7, #FFFFFF 47%, #FFFFFF)',
      borderColorHover: 'rgba(0, 0, 0, 0.1)',
      disabledColor: '#E6E6E6',
      pressedColor: standardColors.White,
      textColor: standardColors.Primary_100,
      disabledTextColor: 'rgba(0, 0, 0, 0.4)',
    },
    dark: {
      backgroundImage: 'linear-gradient(to top, #00304A, #004163)',
      borderColor: '#345B70',
      hoverShadow: '0 0.125em 0.25em 0 rgba(0, 0, 0, 0.4)',
      backgroundImageHover: 'linear-gradient(to top, #01314A, #004163)',
      disabledColor: '#00263B',
      pressedColor: standardColors.Primary_100,
      textColor: standardColors.White,
      disabledTextColor: 'rgba(255, 255, 255, 0.6)',
    },
  },
  slider: {
    backgroundColor: 'rgba(0, 55, 85, 0.12);',
    handle: {
      backgroundColor: '#009EDD',
      backgroundImage: 'linear-gradient(to top, #04A0D9, #00A8E6)',
      boxShadow: '0 0 0 0.375rem rgba(4, 160, 217, 0.2)',
    },
    fill: {
      backgroundColor: standardColors.Primary_100,
      boxShadow: 'inset 0 0.125rem 0.188rem 0 rgba(0, 0, 0, 0.05)',
    },
  },
  stepIndicator: {
    selectedStep: {
      backgroundColor: standardColors.Primary_100,
      textColor: standardColors.White,
      borderColor: standardColors.Primary_100,
    },
    inactiveStep: {
      backgroundColor: standardColors.White,
      textColor: standardColors.Primary_100,
      borderColor: standardColors.GreyC_60,
    },
  },
  tabList: {
    sideGradients: {
      background:
        'linear-gradient(to right, #FFFFFF, rgba(255, 255, 255, 0) 15%, rgba(255, 255, 255, 0) 85%, #FFFFFF)',
    },
    tab: {
      hoverColor: '#009EDD',
    },
  },
  accordionList: {
    hoverColor: standardColors.PrimaryB_30,
  },
};
